import React from "react";
import { HamburgerMenuWrap, LogoImg } from "./elements";
import { Hamburger } from "./Hamburger";
import { Menu } from "./Menu";
import Logo from "../../../assets/images/bestvalue_logo.svg";

export const SPHeader: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <HamburgerMenuWrap>
      <LogoImg alt="logo" src={Logo} />
      <Hamburger open={open} setOpen={setOpen} />
      <Menu open={open} />
    </HamburgerMenuWrap>
  );
};
